import React, {PureComponent} from 'react';

import Error from '../Error';
import TrendWidget from './TrendWidget';
import SummaryWidget from './SummaryWidget';
import BarChartWidget from './BarChartWidget';
import RecentSubmissionsWidget from './RecentSubmissionsWidget';
import Widget from '../Widget';
import NoDataWidget from '../NoDataWidget';
import Dialog from '../Dialog';
import Button from '../Button';
import {parseVariables} from '../../lib/json-logic-utils';
import {isQuestionDeleted} from '../../screens/FormBuilderScreen/shared';

class TemplateWidget extends PureComponent {
  state = {
    error: false,
    confirmDelete: false
  };

  componentDidCatch() {
    const {onError} = this.props;
    this.setState({error: true}, onError);
  }

  handleEditWidget = () => {
    const {onEdit, widget} = this.props;
    onEdit(widget);
  }

  toggleConfirmDelete = () => {
    this.setState(state => ({confirmDelete: !state.confirmDelete}));
  }

  handleDeleteWidget = () => {
    const {onDelete, widget} = this.props;
    onDelete(widget);
  }

  render() {
    const {widget, sheetsById, rows, questions, onHide, preview, id, user, catalog, credentials, filters} = this.props;
    const {error, confirmDelete} = this.state;
    // The API names the widget's kind. A preview built from the form has not been saved yet and so has no name, in
    // which case the same rule the API derives it with applies: a question with no aggregation lists each answer.
    const recentSubmissions = widget.type === 'RECENT_SUBMISSIONS' || (!widget.aggregation && Boolean(widget.groupByQuestion));

    let CustomWidget;

    if (recentSubmissions) {
      CustomWidget = RecentSubmissionsWidget;
    }
    else if (widget.groupByQuestion) {
      CustomWidget = BarChartWidget;
    }
    else if (widget.aggregation) {
      CustomWidget = SummaryWidget;
    }
    else {
      CustomWidget = TrendWidget;
    }

    const parsedWidget = {
      ...widget,
      map: JSON.parse(widget.map),
      filter: JSON.parse(widget.filter)
    };

    // Grab questions that are used in the widget
    const referencedIds = [
      ...parseVariables(parsedWidget.map),
      ...parseVariables(parsedWidget.filter)
    ];
    // Deduplicate questions and get deleted questions out
    const formulaDeletedQuestions = [...new Set(referencedIds)]
      .map(qid => questions && questions[qid])
      .filter(q => q && isQuestionDeleted(q));

    let userOptions = []

    if(user.role !== "USER") {
      userOptions = [
        {title: 'Hide', onClick: () => onHide({source: 'TemplateWidget', widget})},
        {title: 'Edit', onClick: this.handleEditWidget},
        {title: 'Delete', onClick: this.toggleConfirmDelete}
      ]
    }

    return (
      <Widget
        preview={preview}
        id={id} 
        title={widget.title} 
        options={userOptions}
        overlay={confirmDelete && (
          <Dialog
            title="Delete this widget?"
            description="Are you sure you want to delete this widget? This cannot be undone."
            buttons={[
              <Button key="confirm-delete" onClick={this.handleDeleteWidget}>Delete</Button>,
              <Button key="cancel-delete" secondary onClick={this.toggleConfirmDelete}>Cancel</Button>
            ]}
          />
        )}>
        {error ? (
          <Error message="There is a problem with this widget's configuration" />
        ) : rows.length < 1 && !recentSubmissions ? (
          <NoDataWidget
            id={widget.id}
            title={widget.title}
            preview={preview}
            options={userOptions}
            formulaDeletedQuestions={formulaDeletedQuestions}
          />
        ) : (
          <CustomWidget
            id={widget.id}
            widget={parsedWidget}
            title={widget.title}
            options={userOptions}
            sheetsById={sheetsById}
            rows={rows}
            questions={questions}
            preview={preview}
            catalog={catalog}
            credentials={credentials}
            filters={filters}
            formulaDeletedQuestions={formulaDeletedQuestions}
          />
        )}
      </Widget>
    );
  }
}

export default TemplateWidget;
